import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import airconhistoryService from "../services/airconhistory.service";
import { Airconhistoryvalidationschema } from "../components/Validation";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, Link } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import authsService from "../services/auths.service";
import servicingService from "../services/servicing.service";
import checklistService from "../services/checklist.service";
import Airconhistorystatusy from "./Airconhistorystatusy";
import categoryService from "../services/category.service";
import airconhistorystatusService from "../services/airconhistorystatus.service";
import clientService from "../services/client.service";
import analyticsService from "../services/analytics.service";

const Pendingcase = (props) => {
  const userinfo = authsService.userinfo();
  const userinfos = authsService.userdata();
  const client_id = authsService.getclientname();

  const ref = useRef();
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState("");
  const [eventname, setEventname] = useState("create");
  const [ah_id, setAh_id] = useState("");
  const [clientstatusoverview, setClientstatusoverview] = useState([]);

  const [clients, setClients] = useState([]);

  const [airconhistorys, setAirconhistorys] = useState([]);

  const [checklists, setChecklists] = useState([]);
  const [servicings, setServicings] = useState([]);

  const [checkArr, setcheckArr] = useState([]);
  const [servicingArr, setservicingArr] = useState([]);
  const [servicingcostArr, setservicingcostArr] = useState([]);

  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [filter, setFilter] = useState("pending case");
  const [filterclient, setFilterclient] = useState(
    client_id === "democlient" ? "" : client_id
  );
  const [filteraircon, setFilteraircon] = useState(props.aircon_id === undefined ? "" : props.aircon_id);

  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "airconhistory ID", value: "" },
    { label: "airconhistory name", value: "ah_name" },
    { label: "Status", value: "ah_status" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);

  const [categorysfilter, setCategorysfilter] = useState([]);

  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };
  //form initial value
  const ahformik = useFormik({
    initialValues: {
      ah_id: "",
      client_id: props.client_id,
      aircon_id: props.aircon_id,
      ah_name: "",
      checked_list: "",
      service_list: "",
      total_amount: 0,
      additional_amount: 0,
      ah_type: userinfos.login_type == "client" ? "issue" : "maintenance",
      ah_remark: "",
      approvedBy: userinfos.login_type,
      servicedBy: userinfo.user_name,
      ah_status: userinfos.login_type == "client" ? "new case" : "completed",
      user_name: userinfo.user_name,
    },
    validationSchema: Airconhistoryvalidationschema,
    enableReinitialize: true,

    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      /* resetForm({ values: "" }); */
    },
  });
  //use effects
  useEffect(() => {
    getallAirconhistory();
    getallChecklist();
    getallServicing();
    getallCategory();
    getallClient();
    getclientAirconstatusoverview();
  }, []);
  useLayoutEffect(() => {
    getallAirconhistory();
    getclientAirconstatusoverview();
  }, [page, limit, filter, filterclient, search, between, sort]);

  useLayoutEffect(() => {
    setservicingcostArr([]);
    if (eventname == "create") {
      setservicingArr([]);
      setcheckArr([]);
      ahformik.setFieldValue("service_price", 0);
      ahformik.setFieldValue("service_list", "");
      ahformik.setFieldValue("check_list", "");
    } else if (eventname == "edit") {
      ahformik.setFieldValue("approvedBy", userinfos.login_type);
    } else {
    }
    ahformik.setFieldValue("service_price", 0);
    ahformik.setFieldValue("service_list", "0 system service done");
    ahformik.setFieldValue(
      "ah_status",
      ahformik.values.ah_type === "issue" ? "pending case" : "completed"
    );
  }, [ahformik.values.ah_type, eventname]);
  const valuechangefn = () => {
    getallAirconhistory();
  };
  //current event
  const airconhistoryEvent = (eventname, value) => {
    if (value != "") {
      getAirconhistory(value);
      setEventname(eventname);
    }
    setEventname(eventname);
    ahformik.resetForm();
  };
  //get allairconhistory
  const getallAirconhistory = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: filterclient,
      filteraircon: filteraircon,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconhistoryService
      .getallAirconhistory(data)
      .then((res) => {
        console.log(res.data);

        if (res.data.result) {
          setIsLoaded(false);
          setAirconhistorys(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsLoaded(false);
          setAirconhistorys(null);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //filter
  const [filterclientArr, setfilterclientArr] = useState([]);
  const filterclientfn = (value) => {
    setPage(1);
    var index = filterclientArr.indexOf(value);
    if (index > -1) {
      filterclientArr.splice(index, 1);
      setFilterclient(filterclientArr.toString());
    } else {
      filterclientArr.push(value);
      setFilterclient(filterclientArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort == value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort == value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
      " , " +
      format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  //checkbox

  //between
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get airconhistory
  const getAirconhistory = (value) => {
    setIsLoaded(true);
    airconhistoryService
      .getAirconhistory(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          ahformik.setValues({
            ah_id: data.ah_id,
            client_id: data.client_id,
            aircon_id: data.aircon_id,
            ah_name: data.ah_name,
            checked_list: data.checked_list,
            service_list: data.service_list,
            total_amount: data.total_amount,
            additional_amount: data.additional_amount,
            ah_type: data.ah_type,
            ah_remark: data.ah_remark,
            approvedBy: data.approvedBy,
            servicedBy: data.servicedBy,
            ah_status: data.ah_status,
            user_name: userinfo.user_name,
          });
          let che = data.checked_list.split(",");
          setcheckArr(che);
          let ser = data.service_list.split(",");
          setservicingArr(ser);
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //create airconhistory
  const createAirconhistory = () => {
    airconhistoryService
      .createAirconhistory(ahformik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create");
          getallAirconhistory();
          ahformik.resetForm();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //update airconhistory
  const updateAirconhistory = (value) => {
    console.log(JSON.stringify(ahformik.values, null, 2));
    airconhistoryService
      .updateAirconhistory(ahformik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("view");
          getallAirconhistory();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //delete airconhistory
  const deleteAirconhistory = (value) => {
    console.log(value);
    airconhistoryService
      .deleteAirconhistory(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create", "");
          ahformik.resetForm();
          getallAirconhistory();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //get allchecklist
  const getallChecklist = async () => {
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "checklist_name ASC",
      group: "",
    };
    return await checklistService
      .getallChecklist(data)
      .then((res) => {
        if (res.data.result) {
          setChecklists(res.data.result.data);
          console.log(res.data.result.data);
        } else {
          setChecklists([]);
        }
      })
      .catch((err) => {
        setChecklists([]);
      });
  };
  //get allservicing
  const getallServicing = async () => {
    setIsLoaded(true);
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "servicing_name ASC",
      group: "",
    };
    return await servicingService
      .getallServicing(data)
      .then((res) => {
        if (res.data.result) {
          setServicings(res.data.result.data);
          console.log(res.data.result.data);
        } else {
          setServicings([]);
        }
      })
      .catch((err) => {
        setServicings([]);
      });
  };
  //selected check
  const selectedchecklistsfn = (value) => {
    var index = checkArr.indexOf(value);
    if (index > -1) {
      checkArr.splice(index, 1);
      setcheckArr(checkArr);
      /* setSelectedchecklists(checkArr.toString()); */
      ahformik.setFieldValue("checked_list", checkArr.toString());
      console.log(checkArr.toString());
    } else {
      checkArr.push(value);
      setcheckArr(checkArr);
      /* setSelectedchecklists(checkArr.toString()); */
      ahformik.setFieldValue("checked_list", checkArr.toString());
    }
  };
  const selectedcheck = (value) => {
    var index = checkArr.indexOf(value);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  };
  const selectallcheck = (value) => {
    if (checkArr.length === checklists.length) {
      setcheckArr([]);
      ahformik.setFieldValue("checked_list", "0 system checkup found");
    } else {
      let allcheck = value.map((item) => item.checklist_name);
      setcheckArr(allcheck);
      ahformik.setFieldValue("checked_list", allcheck.toString());
    }
  };
  const selectallservice = (value) => {
    if (servicingArr.length === servicings.length) {
      setservicingcostArr([]);
      setservicingArr([]);
      ahformik.setFieldValue("service_price", 0);
      ahformik.setFieldValue("service_list", "0 system service done");
    } else {
      let allservice = value.map((item) => item.servicing_name);
      let allservicecost = value.map((item) => +item.servicing_price);
      setservicingcostArr(allservicecost);
      setservicingArr(allservice);
      console.log(allservicecost.reduce((a, b) => a + b, 0));
      ahformik.setFieldValue("service_price", allservicecost.toString());
      ahformik.setFieldValue("service_list", allservice.toString());
    }
  };
  //selected servicing
  const selectedservicinglistsfn = (value) => {
    var index = servicingArr.indexOf(value);
    if (index > -1) {
      servicingArr.splice(index, 1);
      setservicingArr(servicingArr);
      /* setSelectedchecklists(checkArr.toString()); */
      ahformik.setFieldValue("service_list", servicingArr.toString());
      console.log(servicingArr.toString());
    } else {
      servicingArr.push(value);
      setservicingArr(servicingArr);
      /* setSelectedchecklists(checkArr.toString()); */
      ahformik.setFieldValue("service_list", servicingArr.toString());
    }
  };
  const selectedservicing = (value) => {
    var index = servicingArr.indexOf(value);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  };
  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 30,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "client_fullname",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setClients(res.data.result.data);
          console.log(res.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get allcategory
  const getallCategory = async () => {
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      filtercategory: "case_status",
      search: "",
      between: "",
      sort: "category_rank ASC",
      group: "",
    };
    return await categoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setCategorysfilter(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get allclientstatusoverview
  const getclientAirconstatusoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: filterclient,
      search: "",
      between: "",
      sort: "category_rank ASC",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconstatusoverview(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          setClientstatusoverview(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  /* service list */
  const selectedcolor = (value) => {
    if (value === "completed") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending case") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call airconhistory clicks to request another page.
  if (ismessage === "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  return (
    <div className="">
      <div className="">
        {/*  loader and error handler */}
        {<Toastmessage ref={ref} />}
        {isLoaded ? <Loader /> : <></>}
      </div>
      <div>
        <div className="bg-white rounded shadow-sm">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            {clientstatusoverview.map((clientoverview, index) => (
              <li key={index} className="nav-item" role="presentation">
                <button
                  onClick={() => {
                    setFilter(clientoverview.category_name);
                  }}
                  /*  className="nav-link" */
                  className={
                    filter === clientoverview.category_name
                      ? "nav-link   active text-capitalize"
                      : "nav-link   text-capitalize"
                  }
                  id={clientoverview.category_name}
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  {clientoverview.category_name}(
                  {clientoverview.client_status_count})
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="d-flex  ">
        <h1 className="flex-fill">Cases</h1><div>{/* <button
              onClick={() => {
                navigate("/clientevent");
              }}
              type="submit"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add Client
            </button> */}</div>
      </div>
      {/*  container */}
      <div className="airconhistory-container">
        {/*  modal form */}
        <div
          className="modal"
          id="staticBackdropstatusupdate"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropstatusupdateLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {/*  {eventname=="view"?<></>:<></>} */}
              <div className="modal-body">
                {/* airconhistory form */}
                <div className="card border-0 mb-2">
                  <div className="card-body ">
                    <div className="d-flex">
                      <h5 className="card-title p-0 m-0 me-auto">
                        Case Details
                      </h5>
                      {eventname == "create" ? (
                        <></>
                      ) : (
                        <div
                          className={
                            userinfos.login_type === "dashboard"
                              ? "d-block"
                              : userinfos.login_type === "technition"
                                ? "d-block"
                                : "d-none"
                          }
                        >
                          <div className="dropdown ">
                            <a
                              className="btn btn-sm"
                              role="button"
                              id="airconhistoryeventdropdownMenuLink"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Option
                              {/*  <i
                                className="fa fa-ellipsis-v"
                                aria-hidden="true"
                              ></i> */}
                            </a>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="airconhistoryeventdropdownMenuLink"
                            >
                              <li>
                                <a
                                  onClick={() => {
                                    airconhistoryEvent(
                                      "edit",
                                      ahformik.values.ah_id
                                    );
                                  }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={() =>
                                    airconhistoryEvent(
                                      "delete",
                                      ahformik.values.ah_id
                                    )
                                  }
                                  className={
                                    userinfos.login_type === "technition"
                                      ? "d-none"
                                      : "d-block dropdown-item"
                                  }
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                      <div>
                        <button
                          className="btn btn-sm text-danger"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    {/*client form */}
                    {userinfos.login_type === "client" ? (
                      <>
                        <form onSubmit={ahformik.handleSubmit}>
                          <div className="row">
                            {eventname === "view" ? (
                              <>
                                <div className="col-md-12">
                                  <label
                                    htmlFor="ah_type"
                                    className="form-label"
                                  >
                                    type
                                  </label>
                                  <div className="input-group col-md-6">
                                    <select
                                      id="ah_type"
                                      {...ahformik.getFieldProps("ah_type")}
                                      className="form-select"
                                      disabled={
                                        eventname == "view"
                                          ? true
                                          : eventname == "delete"
                                            ? true
                                            : false
                                      }
                                      aria-label="ah_type"
                                    >
                                      <option value="" disabled>
                                        Select type
                                      </option>
                                      <option value="maintenance">
                                        Maintenance
                                      </option>
                                      <option value="issue">Issue</option>
                                    </select>
                                  </div>
                                  <div>
                                    {ahformik.touched.ah_type &&
                                      ahformik.errors.ah_type ? (
                                      <div className="error">
                                        {ahformik.errors.ah_type}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                {/* checked list */}

                                <div style={{ padding: 10 }}>
                                  <div className="text-secondary d-flex flex-wrap">
                                    <div className="flex-fill">Maintenance</div>
                                    <div></div>
                                    {eventname == "view" ? (
                                      <></>
                                    ) : eventname == "delete" ? (
                                      <></>
                                    ) : (
                                      <>
                                        <div className="form-check">
                                          <input
                                            onChange={() => {
                                              selectallcheck(checklists);
                                            }}
                                            className="form-check-input"
                                            type="checkbox"
                                            id="qwqweeeeeee"
                                            checked={
                                              checkArr.length ===
                                                checklists.length
                                                ? true
                                                : false
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="qwqweeeeeee"
                                          >
                                            Check all
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  <div
                                    className="border rounded p-1"
                                    style={{ height: 250, overflowY: "auto" }}
                                  >
                                    {checklists.map((checklist, index) => (
                                      <div key={index} className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={checklist.checklist_name}
                                          checked={selectedcheck(
                                            checklist.checklist_name
                                          )}
                                          disabled={
                                            eventname == "view"
                                              ? true
                                              : eventname == "delete"
                                                ? true
                                                : false
                                          }
                                          onChange={() =>
                                            selectedchecklistsfn(
                                              checklist.checklist_name
                                            )
                                          }
                                          id={checklist.checklist_name}
                                        />
                                        <label
                                          className=""
                                          htmlFor={checklist.checklist_name}
                                        >
                                          {checklist.checklist_name}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                {ahformik.values.ah_type === "issue" ? (
                                  <>
                                    {/* service list */}
                                    <div style={{ padding: 10 }}>
                                      <div className="text-secondary d-flex flex-wrap">
                                        <div className="flex-fill">
                                          Recomented service
                                        </div>
                                        <div></div>
                                        {eventname == "view" ? (
                                          <></>
                                        ) : eventname == "delete" ? (
                                          <></>
                                        ) : (
                                          <>
                                            <div className="form-check">
                                              <input
                                                onChange={() => {
                                                  selectallservice(servicings);
                                                }}
                                                className="form-check-input"
                                                type="checkbox"
                                                id="trrytrtrtrtrt"
                                                checked={
                                                  servicingArr.length ===
                                                    servicings.length
                                                    ? true
                                                    : false
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="trrytrtrtrtrt"
                                              >
                                                Check all
                                              </label>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div
                                        className="border rounded p-1"
                                        style={{
                                          height: 250,
                                          overflowY: "auto",
                                        }}
                                      >
                                        {servicings.map((servicing, index) => (
                                          <div
                                            key={index}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={servicing.servicing_name}
                                              disabled={
                                                eventname == "view"
                                                  ? true
                                                  : eventname == "delete"
                                                    ? true
                                                    : false
                                              }
                                              checked={selectedservicing(
                                                servicing.servicing_name
                                              )}
                                              onChange={() =>
                                                selectedservicinglistsfn(
                                                  servicing.servicing_name
                                                )
                                              }
                                              id={servicing.servicing_name}
                                            />
                                            <label
                                              className=""
                                              htmlFor={servicing.servicing_name}
                                            >
                                              {servicing.servicing_name}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    </div>

                                    {/* price */}
                                    <div className="col-md-12">
                                      <label
                                        htmlFor="total_amount"
                                        className="form-label"
                                      >
                                        total amount
                                      </label>
                                      <div className="input-group col-md-6">
                                        <input
                                          className="form-control"
                                          placeholder="Enter price"
                                          id="total_amount"
                                          type="number"
                                          disabled={
                                            eventname == "view"
                                              ? true
                                              : eventname == "delete"
                                                ? true
                                                : false
                                          }
                                          {...ahformik.getFieldProps(
                                            "total_amount"
                                          )}
                                        />
                                      </div>
                                      <div>
                                        {ahformik.touched.total_amount &&
                                          ahformik.errors.total_amount ? (
                                          <div className="error">
                                            {ahformik.errors.total_amount}
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                            {/*  reamrks */}
                            <div className="col-md-12">
                              <label htmlFor="ah_remark" className="form-label">
                                Remark
                              </label>
                              <div className="input-group col-md-6">
                                <textarea
                                  className="form-control"
                                  placeholder="Enter remark"
                                  id="serviceah_remark_list"
                                  disabled={
                                    eventname == "view"
                                      ? true
                                      : eventname == "delete"
                                        ? true
                                        : false
                                  }
                                  {...ahformik.getFieldProps("ah_remark")}
                                ></textarea>
                              </div>
                              <div>
                                {ahformik.touched.ah_remark &&
                                  ahformik.errors.ah_remark ? (
                                  <div className="error">
                                    {ahformik.errors.ah_remark}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            {/* <div className="col-md-12">
                              <label htmlFor="ah_status" className="form-label">
                                status
                              </label>
                              <div className="input-group col-md-6">
                                <select
                                  id="ah_status"
                                  {...ahformik.getFieldProps("ah_status")}
                                  className="form-select"
                                  disabled={
                                    eventname == "view"
                                      ? true
                                      : eventname == "create"
                                      ? true
                                      : eventname == "delete"
                                      ? true
                                      : false
                                  }
                                  aria-label="ah_status"
                                >
                                  <option value="" disabled>
                                    Select status
                                  </option>
                                  {categorysfilter.map(
                                    (statuscategorys, index) => (
                                      <option
                                        key={index}
                                        value={statuscategorys.category_name}
                                      >
                                        {statuscategorys.category_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div>
                                {ahformik.touched.ah_status &&
                                ahformik.errors.ah_status ? (
                                  <div className="error">
                                    {ahformik.errors.ah_status}
                                  </div>
                                ) : null}
                              </div>
                            </div> */}
                            {/* airconhistory event buttons */}
                            <div className="col-md-12 pt-2 pb-2">
                              {eventname === "create" ? (
                                <>
                                  <button
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    disabled={
                                      !ahformik.isValid || !ahformik.dirty
                                    }
                                    onClick={() => createAirconhistory()}
                                    className="btn btn-primary me-2"
                                  >
                                    Create
                                  </button>
                                  {/*  <button
                                    disabled={!ahformik.dirty}
                                    onClick={ahformik.handleReset}
                                    className="btn btn-secondary"
                                  >
                                    Clear
                                  </button> */}
                                </>
                              ) : eventname === "edit" ? (
                                <>
                                  <button
                                    onClick={() => updateAirconhistory()}
                                    className="btn btn-primary me-2"
                                  >
                                    Update
                                  </button>
                                  <a
                                    onClick={() => {
                                      airconhistoryEvent(
                                        "view",
                                        ahformik.values.ah_id
                                      );
                                    }}
                                    className="btn btn-secondary"
                                  >
                                    Cancel
                                  </a>
                                </>
                              ) : eventname === "delete" ? (
                                <>
                                  <button
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() =>
                                      deleteAirconhistory(ahformik.values.ah_id)
                                    }
                                    className="btn btn-danger me-2 "
                                  >
                                    Delete
                                  </button>
                                  <a
                                    onClick={() => {
                                      airconhistoryEvent(
                                        "view",
                                        ahformik.values.ah_id
                                      );
                                    }}
                                    className="btn btn-secondary"
                                  >
                                    Cancel
                                  </a>
                                </>
                              ) : (
                                <>
                                  {/* <button
                                onClick={() => {
                                  airconhistoryEvent("create", "");
                                  ahformik.handleReset();
                                }}
                                className="btn btn-primary"
                              >
                                Close
                              </button> */}
                                </>
                              )}
                            </div>
                          </div>
                        </form>
                      </>
                    ) : (
                      <>
                        {/*admin and technition form */}
                        <form onSubmit={ahformik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-12">
                              <label htmlFor="ah_type" className="form-label">
                                type
                              </label>
                              <div className="input-group col-md-6">
                                <select
                                  id="ah_type"
                                  {...ahformik.getFieldProps("ah_type")}
                                  className="form-select"
                                  disabled={
                                    eventname == "view"
                                      ? true
                                      : eventname == "delete"
                                        ? true
                                        : false
                                  }
                                  aria-label="ah_type"
                                >
                                  <option value="" disabled>
                                    Select type
                                  </option>
                                  <option value="maintenance">
                                    Maintenance
                                  </option>
                                  <option value="issue">Issue</option>
                                </select>
                              </div>
                              <div>
                                {ahformik.touched.ah_status &&
                                  ahformik.errors.ah_status ? (
                                  <div className="error">
                                    {ahformik.errors.ah_status}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            {/* checked list */}

                            <div style={{ padding: 10 }}>
                              <div className="text-secondary d-flex flex-wrap">
                                <div className="flex-fill">Maintenance</div>
                                <div></div>
                                {eventname == "view" ? (
                                  <></>
                                ) : eventname == "delete" ? (
                                  <></>
                                ) : (
                                  <>
                                    <div className="form-check">
                                      <input
                                        onChange={() => {
                                          selectallcheck(checklists);
                                        }}
                                        className="form-check-input"
                                        type="checkbox"
                                        id="sdffdfdfd"
                                        checked={
                                          checkArr.length === checklists.length
                                            ? true
                                            : false
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="sdffdfdfd"
                                      >
                                        Check all
                                      </label>
                                    </div>
                                  </>
                                )}
                              </div>

                              <div
                                className="border rounded p-1"
                                style={{ height: 250, overflowY: "auto" }}
                              >
                                {checklists.map((checklist, index) => (
                                  <div key={index} className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={checklist.checklist_name}
                                      checked={selectedcheck(
                                        checklist.checklist_name
                                      )}
                                      disabled={
                                        eventname == "view"
                                          ? true
                                          : eventname == "delete"
                                            ? true
                                            : false
                                      }
                                      onChange={() =>
                                        selectedchecklistsfn(
                                          checklist.checklist_name
                                        )
                                      }
                                      id={checklist.checklist_name}
                                    />
                                    <label
                                      className=""
                                      htmlFor={checklist.checklist_name}
                                    >
                                      {checklist.checklist_name}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {ahformik.values.ah_type === "issue" ? (
                              <>
                                {/* service list */}
                                <div style={{ padding: 10 }}>
                                  <div className="text-secondary d-flex flex-wrap">
                                    <div className="flex-fill">
                                      Recomented service
                                    </div>
                                    <div></div>
                                    {eventname == "view" ? (
                                      <></>
                                    ) : eventname == "delete" ? (
                                      <></>
                                    ) : (
                                      <>
                                        <div className="form-check">
                                          <input
                                            onChange={() => {
                                              selectallservice(servicings);
                                            }}
                                            className="form-check-input"
                                            type="checkbox"
                                            id="sdsdsd45533"
                                            checked={
                                              servicingArr.length ===
                                                servicings.length
                                                ? true
                                                : false
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="sdsdsd45533"
                                          >
                                            Check all
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div
                                    className="border rounded p-1"
                                    style={{ height: 250, overflowY: "auto" }}
                                  >
                                    {servicings.map((servicing, index) => (
                                      <div key={index} className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={servicing.servicing_name}
                                          disabled={
                                            eventname == "view"
                                              ? true
                                              : eventname == "delete"
                                                ? true
                                                : false
                                          }
                                          checked={selectedservicing(
                                            servicing.servicing_name
                                          )}
                                          onChange={() =>
                                            selectedservicinglistsfn(
                                              servicing.servicing_name
                                            )
                                          }
                                          id={servicing.servicing_name}
                                        />
                                        <label
                                          className=""
                                          htmlFor={servicing.servicing_name}
                                        >
                                          {servicing.servicing_name}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                {/* price */}
                                <div className="col-md-12">
                                  <label
                                    htmlFor="total_amount"
                                    className="form-label"
                                  >
                                    total amount
                                  </label>
                                  <div className="input-group col-md-6">
                                    <input
                                      className="form-control"
                                      placeholder="Enter price"
                                      id="total_amount"
                                      type="number"
                                      disabled={
                                        eventname == "view"
                                          ? true
                                          : eventname == "delete"
                                            ? true
                                            : false
                                      }
                                      {...ahformik.getFieldProps(
                                        "total_amount"
                                      )}
                                    />
                                  </div>
                                  <div>
                                    {ahformik.touched.total_amount &&
                                      ahformik.errors.total_amount ? (
                                      <div className="error">
                                        {ahformik.errors.total_amount}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {/*  reamrks */}
                            <div className="col-md-12">
                              <label htmlFor="ah_remark" className="form-label">
                                Remark
                              </label>
                              <div className="input-group col-md-6">
                                <textarea
                                  className="form-control"
                                  placeholder="Enter remark"
                                  id="serviceah_remark_list"
                                  disabled={
                                    eventname == "view"
                                      ? true
                                      : eventname == "delete"
                                        ? true
                                        : false
                                  }
                                  {...ahformik.getFieldProps("ah_remark")}
                                ></textarea>
                              </div>
                              <div>
                                {ahformik.touched.ah_remark &&
                                  ahformik.errors.ah_remark ? (
                                  <div className="error">
                                    {ahformik.errors.ah_remark}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            {/* <div className="col-md-12">
                              <label htmlFor="ah_status" className="form-label">
                                status
                              </label>
                              <div className="input-group col-md-6">
                                <select
                                  id="ah_status"
                                  {...ahformik.getFieldProps("ah_status")}
                                  className="form-select"
                                  disabled={
                                    eventname == "view"
                                      ? true
                                      : eventname == "delete"
                                      ? true
                                      : false
                                  }
                                  aria-label="ah_status"
                                >
                                  <option value="" disabled>
                                    Select status
                                  </option>
                                  {categorysfilter.map(
                                    (statuscategorys, index) => (
                                      <option
                                        key={index}
                                        value={statuscategorys.category_name}
                                      >
                                        {statuscategorys.category_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div>
                                {ahformik.touched.ah_status &&
                                ahformik.errors.ah_status ? (
                                  <div className="error">
                                    {ahformik.errors.ah_status}
                                  </div>
                                ) : null}
                              </div>
                            </div> */}
                            {/* airconhistory event buttons */}
                            <div className="col-md-12 pt-2 pb-2">
                              {eventname === "create" ? (
                                <>
                                  <button
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    disabled={
                                      !ahformik.isValid || !ahformik.dirty
                                    }
                                    onClick={() => createAirconhistory()}
                                    className="btn btn-primary me-2"
                                  >
                                    Create
                                  </button>
                                  {/* <button
                                    disabled={!ahformik.dirty}
                                    onClick={ahformik.handleReset}
                                    className="btn btn-secondary"
                                  >
                                    Clear
                                  </button> */}
                                </>
                              ) : eventname === "edit" ? (
                                <>
                                  <button
                                    onClick={() => updateAirconhistory()}
                                    className="btn btn-primary me-2"
                                  >
                                    Update
                                  </button>
                                  <a
                                    onClick={() => {
                                      airconhistoryEvent(
                                        "view",
                                        ahformik.values.ah_id
                                      );
                                    }}
                                    className="btn btn-secondary"
                                  >
                                    Cancel
                                  </a>
                                </>
                              ) : eventname === "delete" ? (
                                <>
                                  <button
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() =>
                                      deleteAirconhistory(ahformik.values.ah_id)
                                    }
                                    className="btn btn-danger me-2 "
                                  >
                                    Delete
                                  </button>
                                  <a
                                    onClick={() => {
                                      airconhistoryEvent(
                                        "view",
                                        ahformik.values.ah_id
                                      );
                                    }}
                                    className="btn btn-secondary"
                                  >
                                    Cancel
                                  </a>
                                </>
                              ) : (
                                <>
                                  {/* <button
                                onClick={() => {
                                  airconhistoryEvent("create", "");
                                  ahformik.handleReset();
                                }}
                                className="btn btn-primary"
                              >
                                Close
                              </button> */}
                                </>
                              )}
                            </div>
                          </div>
                        </form>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer d-none">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Understood
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* tebale header part search,filter,sort */}
        <div
          className={
            userinfos.login_type === "dashboard"
              ? "d-md-flex  mb-2"
              : "d-none"
          }
        >
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Client
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Client</li>
              {clients.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterclientfn(filterdata.client_id)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.client_fullname}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* filter status*/}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Status
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              {/* <li className="text-secondary">Status</li> */}
              {categorysfilter.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* create airconhistory */}
          {/*  <div className="m-1 ms-auto">
            <button
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropstatusupdate"
              onClick={() => {
                setEventname("create", "");
                ahformik.handleReset();
              }}
              type="submit"
              className="btn btn-primary   w-100"
            >
              <i className="fa fa-plus-circle"></i>
            </button>
          </div> */}

          {/* search */}
          <div className=" m-1 d-none">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1  ms-auto">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
        </div>
        {/* table section*/}
        <div>
          {airconhistorys ? (
            <>
              {airconhistorys.map((data, index) => (
                <div className="card shadow-sm border-0 mb-2" key={index}>
                  <div className="card-body">
                    <div className="card-title mb-0 pb-0 d-flex flex-wrap fw-bolder">
                      <div className="flex-fill">{data.ah_type}</div>
                      <div className="me-2">
                        {data.ah_type === "issue" ? (
                          <>${data.total_amount}</>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div onClick={() => setAh_id(data.ah_id)}>
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#asasasas"
                          className={selectedcolor(data.ah_status)}
                        >
                          {data.ah_status}
                        </span>
                      </div>
                    </div>
                    <div style={{ fontSize: 12 }}>
                      <span
                        className=" text-secondary  text-capitalize"
                        style={{}}
                      >
                        ID:{data.ah_id}/created:{data.createdBy}/date:
                        {data.createdAt}
                      </span>
                    </div>
                    <div className="textwrapmulti">{data.checked_list}</div>

                    <div className="textwrapmulti">
                      {" "}
                      <span style={{ fontWeight: 500 }}>Remarks:</span>
                      {data.ah_remark}
                    </div>
                    {data.ah_type === "issue" &&
                      data.ah_status !== "completed" ? (
                      <div className="textwrapmulti border border-danger rounded p-1">
                        <span style={{ fontWeight: 500 }}>Recomentation:</span>
                        {data.service_list}
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="text-end">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdropstatusupdate"
                        onClick={() => airconhistoryEvent("view", data.ah_id)}
                        className="btn btn-sm mt-2 btn-light me-2 "
                      >
                        View more{" "}
                        {/* <i className="fa fa-chevron-right"></i> */}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="alert alert-secondary">0 data found</div>
          )}
        </div>
      </div>
      {/*  status update */}
      <div>
        <div
          className="modal"
          id="asasasas"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="asasasas"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex flex-wrap">
                  <div className="flex-fill">
                    <div className="fw-bold">Status</div>
                  </div>
                  <div className="">
                    <div>
                      <button
                        className="btn btn-sm text-danger"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
                <Airconhistorystatusy
                  changefn={valuechangefn}
                  ah_id={ah_id}
                  ah_status={ahformik.values.ah_status}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pendingcase;
